import { createThemedUseStyles } from "theme";

export default createThemedUseStyles(theme => ({
  main: {
    fontFamily: theme.fontFamily
  },
  headerContent: {},
  mainContent: {}
}));
